export enum LANGUAGE {
  EN = 'EN',
  ES = 'ES',
}
